import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export function HeroProofRotator({ proofPoints }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const count = proofPoints.length;

  useEffect(() => {
    if (count < 2 || paused || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const timer = window.setInterval(() => setIndex((current) => (current + 1) % count), 6000);
    return () => window.clearInterval(timer);
  }, [count, paused]);

  useEffect(() => { if (index >= count) setIndex(0); }, [count, index]);

  if (!count) return <div className="min-h-[64px] mb-7" aria-hidden="true" />;
  const current = proofPoints[index];
  const move = (direction) => setIndex((value) => (value + direction + count) % count);
  const handleBlur = (event) => { if (!event.currentTarget.contains(event.relatedTarget)) setPaused(false); };

  return (
    <div className="min-h-[64px] mb-7 border-l-2 border-brand-red pl-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-5 max-w-4xl" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocus={() => setPaused(true)} onBlur={handleBlur} data-testid="hero-proof-rotator">
      <div key={current.id} className="hero-proof-enter min-w-0">
        <p className="font-body text-xs uppercase tracking-widest font-bold text-white/60">Live directory proof</p>
        <p className="font-body text-lg text-white leading-relaxed mt-1" data-testid="hero-proof-text">{current.text} <Link to={current.href} className="font-bold underline underline-offset-4 decoration-white/50 hover:decoration-white whitespace-nowrap" data-testid="hero-proof-link">{current.action} →</Link></p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className="font-body text-xs text-white/60 tabular-nums" data-testid="hero-proof-position">{String(index + 1).padStart(2, "0")}/{String(count).padStart(2, "0")}</span>
        <button onClick={() => move(-1)} className="w-10 h-10 inline-flex items-center justify-center text-white border border-white/35 hover:border-white rounded-md transition-colors" aria-label="Previous proof point" title="Previous proof point" data-testid="hero-proof-previous"><ArrowLeft className="w-4 h-4" /></button>
        <button onClick={() => move(1)} className="w-10 h-10 inline-flex items-center justify-center text-white border border-white/35 hover:border-white rounded-md transition-colors" aria-label="Next proof point" title="Next proof point" data-testid="hero-proof-next"><ArrowRight className="w-4 h-4" /></button>
      </div>
    </div>
  );
}